import { format } from '@teetsh/app/src/utils/time/format';
import { UserLocale } from '@teetsh/app/src/types/user';
import { AppelsStatsPDFSettings } from 'containers/RegistreAppel/Print/types';

interface Props {
  from: Date;
  to: Date;
  eleveId?: string;
  lng: UserLocale;
  tz: string;
  settings: AppelsStatsPDFSettings;
}

export function buildAppelsStatsPDFParams({
  from,
  to,
  eleveId,
  lng,
  tz,
  settings,
}: Props) {
  const params = new URLSearchParams({
    from: format(from, lng),
    to: format(to, lng),
    lng,
    tz,
    fontSize: (settings.fontSize || 14).toString(),
    bgColor: settings.bgColor || 'white',
    marginTop: (settings.marginTop ?? 6).toString(),
    marginRight: (settings.marginRight ?? 6).toString(),
    marginBottom: (settings.marginBottom ?? 6).toString(),
    marginLeft: (settings.marginLeft ?? 6).toString(),
  });

  if (settings.font) {
    params.set('font', settings.font);
  }

  if (eleveId) {
    params.set('eleve_id', eleveId);
  }

  return params;
}
